// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import { AlertSuccess } from '@rover/icons';
import { Heading, Text } from '@rover/react-lib/components/typography';
import { ContactInfoConstants } from '@rover/app/js/constants/translationConstants';

import { DSToken } from '@rover/react-lib/styles';

type Props = {
  isComplete: boolean,
  titleText: string,
};

const SectionTitleWrapper: StyledComponent<{}> = styled.div`
  position: relative;
`;

const SectionTitleHeading: StyledComponent<{}> = styled(Heading)`
  margin-bottom: 0;
`;

const Circle: StyledComponent<{}> = styled.div`
  border: 1px solid ${DSToken.BORDER_COLOR_PRIMARY};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  left: -45px;
`;

const StyledAlertSuccess: StyledComponent<
  React$ElementConfig<typeof AlertSuccess>,
  {},
  any
> = styled(AlertSuccess)`
  fill: ${DSToken.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE};
  position: absolute;
  left: -45px;
`;

const StyledSubHeading: StyledComponent<{ isComplete: boolean }> = styled(Text)`
  color: ${props =>
    props.isComplete ? DSToken.INTERACTIVE_TEXT_COLOR_PRIMARY_ACTIVE : DSToken.TEXT_COLOR_ERROR};
  margin-bottom: ${DSToken.SPACE_2X};
`;

const renderSubheading = (isComplete: boolean) =>
  isComplete ? (
    <StyledSubHeading as="div" size="200" isComplete={isComplete}>
      {ContactInfoConstants.complete}
    </StyledSubHeading>
  ) : (
    <StyledSubHeading as="div" size="200" isComplete={isComplete}>
      {ContactInfoConstants.incomplete}
    </StyledSubHeading>
  );

const SectionTitle = ({ isComplete, titleText }: Props): Node => (
  <SectionTitleWrapper>
    {isComplete ? <StyledAlertSuccess /> : <Circle />}
    <SectionTitleHeading size="300">{titleText}</SectionTitleHeading>
    {renderSubheading(isComplete)}
  </SectionTitleWrapper>
);

export default SectionTitle;



// WEBPACK FOOTER //
// ../react-lib/src/pages/conversations/EmergencyFormPage/components/common/SectionTitle.jsx